<template>
  <div
    v-if="other"
    class="user-chat fill-main"
  >
    <div class="user row">
      <user-image :user-id="other.id" />
      <h2>{{ other.first_name }} {{ other.last_name }}</h2>
    </div>
    <chat-room
      v-if="userData && id"
      :room="room"
      :show-sidebar="false"
    />
    <div v-else>
      You aren't logged in
    </div>
  </div>
  <div v-else-if="status === 'loading'">
    Loading user information...
  </div>
  <div v-else>
    Sorry, this user doesn't exist
  </div>
</template>

<script>
import ChatRoom from '../../components/GGChatRoom.vue';
import UserImage from '../../components/UserImage.vue';

export default {
  name: 'MessageProfile',
  components: {
    ChatRoom,
    UserImage,
  },
  data() {
    return {
      status: 'loading',
      other: null,
    };
  },
  computed: {
    id() { return parseInt(this.$route.params.id, 10); },
    room() {
      if (this.userData) {
        const users = [this.id, this.userData.id];
        users.sort();
        return `_m2m.${users.join('.')}`;
      }
      return null;
    },
  },
  async mounted() {
    const response = await this.api({ url: `users/${this.id}/` });
    if (response.ok) {
      this.other = response.body;
    }
    this.status = null;
  },
};
</script>

<style lang="scss" scoped>
.row h2 {
  margin-left: 5px;
}
</style>
